<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
        <el-container style="height:500px;margin-right:10px">
          <el-aside border="1px" style="border:1px">
            <div class="center top10">              
              <el-avatar :size="100"  src="" @error="errorHandler">
                <img :src="member.imageUrl"/>              
              </el-avatar>
            </div>
            <el-row>
              <el-col :span="24"  class="center">
                {{member.name}}
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8"  class="center">
                <div class="number">
                  {{member.point}}
                </div>
                  积分
              </el-col>
              <el-col :span="8" class="center">
                <div class="number">
                  {{member.reward}}
                </div>
                  奖励金
              </el-col>
              <el-col :span="8" class="center">
                <div class="number">                  
                  {{member.value}}
                </div>
                  储值
              </el-col>
            </el-row>
            <el-row class="top10 left10" >
              <el-col :span="22" >
                编号：{{member.number}}
              </el-col>
            </el-row>
            <el-row class="top10 left10">
              <el-col :span="24" >
                手机号：{{member.mobile}}
              </el-col>
            </el-row>
            <el-row class="top10 left10">
              <el-col :span="24" >
                vip：{{member.vipState}}
              </el-col>
            </el-row>
            <el-row class="top10 left10">
              <el-col :span="24" >
                性别：{{member.gender}}
              </el-col>
            </el-row>
            <el-row class="top10 center"  >              
              <el-button type="primary" v-on:click="readMember" >会员登陆</el-button>
              <el-button type="success" v-on:click="resetMember" v-if="memberLogin==true" >退出登陆</el-button>
            </el-row>
          </el-aside>
          <el-container>
            <el-main v-model="consume">
              <el-form label-width="100px">      
                <el-form-item label="消费金额">
                  <el-col :span="12">
                    <el-input v-model="consume.paidInfo.productAmount"></el-input>
                  </el-col>
                  <el-col :span="12" style="text-align:right">
                     <el-link icon="el-icon-edit">备注</el-link>
                  </el-col>
                </el-form-item>
                <el-divider></el-divider>
                <el-form-item label="附加信息">
                  <el-col :span="12">
                    <el-input v-model="consume.attach"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="介绍人卡号">
                  <el-col :span="12">
                    <el-input v-model="consume.memo"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="密码" v-if="isInputPassword">
                  <el-col :span="12">
                    <el-input show-password v-model="consume.password" placeholder="请输入密码"></el-input>
                  </el-col>
                </el-form-item>
                <el-divider></el-divider>

                <el-form-item>
                  <!-- <el-checkbox 
                    v-model="couponChecked"  
                    v-if="memberLogin==true" 
                    @change="checkCouponPay" >
                    代金券支付{{consume.paidInfo.CouponPaid}}元
                  </el-checkbox> -->
                  <el-checkbox 
                    v-if="memberLogin==true" 
                    v-model="pointChecked">
                    积分支付{{pointPaid}}元
                  </el-checkbox>
                  <el-checkbox 
                    v-if="memberLogin==true" 
                    v-model="valueChecked">
                    储值支付{{valuePaid}}元
                  </el-checkbox>
                  <el-checkbox 
                    v-if="memberLogin==true" 
                    v-model="rewardChecked">
                    奖励金支付{{rewardPaid}}元
                  </el-checkbox>
                </el-form-item>
                <el-form-item>
                  <el-button type="warning" @click="setPayType(1)" plain >现金支付{{cashPaid}}元</el-button>
                  <el-button type="success" @click="setPayType(2)" plain>微信/支付宝{{thirdPaid}}元</el-button>
                  <el-button type="info" @click="setPayType(3)" plain>其他支付{{otherPaid}}元</el-button>
                </el-form-item>
          
                <el-row class="top10 center"  >              
                  <el-button type="primary" v-on:click="checkQuickConsmue" >结算</el-button>
                </el-row>
              </el-form>   
            </el-main>
          </el-container>
        </el-container>
        
      <GetMember v-bind:dialogMember="dialogMember" @UpdateMember="UpdateMember"></GetMember>
      <GetPayCode v-bind:dialogPayCode="dialogPayCode" @UpdatePayCode="UpdatePayCode"></GetPayCode>
    </section>  
  </section>  
</template>
<script  type='text/ecmascript-6'>
  import GetMember from '@/components/GetMember'
  import GetPayCode from '@/components/GetPayCode'
  export default {
    props:{
    },
    data (){
      return {
        member:{
          id: '' //https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png 默认头像图片
        },
        consume:{
          paidInfo:{}
        },
        payType:0,
        memberLogin:false,
        couponChecked:false,
        pointChecked:false,
        valueChecked:false,
        rewardChecked:false,
        dialogMember: {
          title: '',
          isShow:false
        },
        dialogPayCode: {
          isShow:false
        },   
      }
    },
    components:{
      GetMember,
      GetPayCode
    },
    computed:{
      pointPaid: function(){
        if(this.consume.paidInfo.productAmount ==0||this.consume.paidInfo.productAmount==undefined||
				this.pointChecked ==false || this.member.id=='' || this.member.isNormalVip==false){
					return 0;
				}
				if(this.consume.paidInfo.productAmount * this.member.pointPayLimit > this.member.pointValue){						
					return this.member.pointValue;
				}else{
					return this.consume.paidInfo.productAmount * this.member.pointPayLimit;
				}
      },
      valuePaid: function(){
				if(this.consume.paidInfo.productAmount==0||this.consume.paidInfo.productAmount==undefined||
				this.valueChecked ==false || this.member.id==''){
					return 0;
				}
				if(this.consume.paidInfo.productAmount -this.pointPaid> this.member.value){
					return this.member.value;
				}else{
					return this.consume.paidInfo.productAmount -this.pointPaid;
				}
      },
      rewardPaid: function(){
				if(this.consume.paidInfo.productAmount==0||this.consume.paidInfo.productAmount==undefined||
				this.rewardChecked ==false || this.member.id==''){
					return 0;
				}
				if(this.consume.paidInfo.productAmount -this.pointPaid-this.valuePaid> this.member.reward){
					return this.member.reward;
				}else{
					return this.consume.paidInfo.productAmount -this.pointPaid-this.valuePaid;
				}
			},
      leftPaid:function(){
        let value= this.consume.paidInfo.productAmount - this.pointPaid
        - this.valuePaid - this.rewardPaid;
        return value
      },
      cashPaid:function(){
        if(this.payType==1)
          return this.leftPaid
        else 
          return 0
      },      
      thirdPaid:function(){
        if(this.payType==2)
          return this.leftPaid
        else 
          return 0
      },      
      otherPaid:function(){
        if(this.payType==3)
          return this.leftPaid
        else 
          return 0
      },
      isInputPassword:function(){
        if(this.valuePaid>0||this.pointPaid>0||this.rewardPaid>0){
          return true
        }else {
          return false
        }
      }
    },
    mounted(){   
      this.resetMember()
      this.resetConsume()
    },
    methods:{  
      resetMember(){
        this.member ={
          name:'游客',
          point:0,
          reward:0,
          value:0,
          vip:'',
          id:'',
          number:'',
          mobile:'',
          imageUrl:'',
          gender:'未知',
          vipState:'',
          isNormalVip:false
        }
        this.memberLogin = false
      },
      readMember(){
        this.dialogMember.isShow = true
      },
      UpdateMember(obj){
        this.member = obj
        this.memberLogin = true
      },
      resetConsume(){
        this.consume={
          memberId:'',
          chainStoreId:0,
          merchantId:0,
          attach:'',
          memo:'',
          password:'',
          paidInfo:{
            receivableAmount:0,
            productAmount:0,
            receiptAmount:0,
            pointPaid:0,
            rewardPaid:0,
            ValuePaid:0,
            CouponPaid:0,
            thirdPaid:0,
            cashPaid:0,
            otherPaid:0,
            PayCode:''
          }
        }
      },
      errorHandler(){
        return true;
      },
      checkCouponPay(val){

      },      
      setPayType(type){
        this.payType = type
      },
      checkQuickConsmue(){
        if(this.consume.productAmount<=0){
          this.$message.warning('请输入消费金额金额!')
          return 
        }
        if(this.payType==0 && this.thirdPaid>0){
          this.$message.warning('请选择支付方式!')
          return 
        }
        if(this.thirdPaid>0){
          this.dialogPayCode.isShow = true
        }else{
          this.submitQuickConsmue()
        }
      },
      UpdatePayCode(code){
        this.consume.paidInfo.PayCode = code
        this.submitQuickConsmue()
      },
      submitQuickConsmue(){ 
        var user = this.$cookie.getJSON('user');
        this.consume.chainStoreId = user.chainStoreId
        this.consume.merchantId = user.merchantId
        this.consume.memberId = this.member.id
        this.consume.paidInfo.pointPaid = this.pointPaid
        this.consume.paidInfo.valuePaid = this.valuePaid
        this.consume.paidInfo.rewardPaid = this.rewardPaid
        this.consume.paidInfo.cashPaid = this.cashPaid
        this.consume.paidInfo.thirdPaid = this.thirdPaid
        this.consume.paidInfo.otherPaid = this.otherPaid
        this.consume.paidInfo.receivableAmount = this.consume.paidInfo.productAmount 
        this.consume.paidInfo.receiptAmount = this.consume.paidInfo.productAmount 
        debugger
        this.consume.userAccount = user.userAccount
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/Comsune/QuickConsume',         
          data:that.consume
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
            that.resetMember()
            that.resetConsume()
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      }
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.el-aside {
  background-color: #D3DCE6;
  color: #333;
}
  
.el-main {
  background-color: #E9EEF3;
  color: #333;
}
.center{
  text-align center
}
.number{
  color red
  font-size 14px
}
.top10{
  margin-top 10px;
}
.left10{
  margin-left 10px;
}
</style>